module.exports = __webpack_public_path__ + "img/ha_end.e5f99594.png";